


export const types = {
    
    addTopping: '[ PIZZA ] Añadir Topping',
    deleteTopping: '[ PIZZA ] Borrar Topping',
    addClient: '[ PIZZA ] Agregar cliente',
    finishComanda: '[ PIZZA ] Finalizar pedido',
    cleanComanda: '[ PIZZA ] Limpiar Pizza',
    
    
    getToppings: '[ TOPPINGS ] Obtener toppings',
    createTopping: '[ TOPPINGS ] Crear Toppings',
    deleteTops: '[ TOPPINGS ] Borrar Topping',

    getPizzas: '[ PIZZA FLAMA ] Obtener pizaas',
    createPizza: '[ PIZZA FLAMA ] Crear Pizza',
    deletePizzaF: '[ PIZZA FLAMA ] Borrar Pizza',

    authLogin: '[ AUTH ] Login',
    authCheckingFinish: '[ AUTH ] Checking token',

    addPizza: '[ PIZZA FLAMA ] Añadir al carrito',
    deletePizza: '[PIZZA FLAMA ] Borrar del carrito',
    addCantidad: '[PIZZA FLAMA] Sumar cantidad',
    restarQty: '[PIZZA FLAMA] Restar cantidad',
    finishTicket: '[PIZZA FLAMA] Finalizar ticket'
}